/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

function saveGridItemData(collectionTitle, collectionURL, productHandle) {
  window.localStorage.setItem("breadcrumbsPDP", JSON.stringify({
    collection_title: collectionTitle,
    collection_url: collectionURL,
    product_handle: productHandle
  }));
}

window.addEventListener("theme:cart:added", async function() {
  const cart = await(await fetch("https://looplabb.com/cart.js")).json();
  const itemCountElements = document.querySelectorAll(".cart__bubble-item");



  for(const el of itemCountElements) {
    el.innerText = cart.item_count;
  }

  const drawerTotalPrice = document.querySelector(".cart-drawer__foot--subtotal");
  drawerTotalPrice.children[1].innerText = `${window.theme.formatMoney(cart.total_price, theme.moneyFormat) }`;
});

class CustomFilterButton extends HTMLElement {
  #filterParams = this.dataset.params.split("|");
  #filterMap = new Map();

  constructor() {
    super();
    this.#createFilterObj();
    this.addEventListener("click", this.applyFilters.bind(this));
  }

  #createFilterObj() {
    if(this.#filterParams) {
      for(const filterParam of this.#filterParams) {
        const param = filterParam.split("=")[0];
        const value = filterParam.split("=")[1];

        if(!this.#filterMap.get(param)) {
          this.#filterMap.set(param, []);
        }

        this.#filterMap.get(param).push(value);
      }
    }
  }

  applyFilters() {
    const filterContainer = document.querySelector("form[data-collection-filters-form]");

    if(filterContainer) {
      for(const param of this.#filterMap.keys()) {
        const elements = filterContainer.querySelectorAll(`.filter__input[name="${param}"]`);
        const valuesArr = this.#filterMap.get(param);

        for(const element of elements) {
          const value = element.getAttribute("value");
          if(valuesArr.includes(value)) {
            if(!element.checked) {
              element.click();
            }
          } else {
            if(element.checked) {
              element.click();
            }
          }
        }
      }
    }
  }
} 

customElements.define("custom-filter-button", CustomFilterButton);

window.addEventListener("DOMContentLoaded", function() {
  /* PRODUCT GALLERY BUTTON */
  const galleryBtn = document.querySelector(".product-gallery--more");
  if(galleryBtn) {
    galleryBtn.addEventListener("click", function() {
      galleryBtn.parentElement.classList.remove("hide-images");
      galleryBtn.style.display = "none";
    });
  }

  /* COLLECTION FILTER */
  const filterBtn = document.querySelector(".collection--desktop-filter-btn");
  const filterContainer = document.querySelector(".collection__filters");
  if(filterBtn && filterContainer) {
    filterBtn.addEventListener("click", function() {
      if(filterBtn.getBoundingClientRect().top == 10) {
        filterContainer.style.setProperty("--sticky-height", `${filterBtn.parentElement.getBoundingClientRect().height}px`);
      } else {
        filterContainer.style.setProperty("--sticky-height", 0);
      }
      filterBtn.classList.toggle("hide");
      filterContainer.classList.toggle("hide");
    });
  }
});

class RAOQuickBuy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector("form");
    const idInput = form.querySelector(`input[name="id"]`);
    const container = this.parentElement;

    container.style.setProperty("--quick-buy-height", `-${this.getBoundingClientRect().height / 2}px`);

    form.addEventListener("change", function(e) {
      idInput.value = e.target.value;
      form.classList.remove("red-border");
    });
  }
}

customElements.define("rao-quick-buy", RAOQuickBuy);

class RAOQuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector("form");
    const idInput = form.querySelector(`input[name="id"]`);

    form.addEventListener("change", function(e) {
      idInput.value = e.target.value;
      form.classList.remove("red-border");
    });
  }
}

customElements.define("rao-quick-view", RAOQuickView);

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.movementInit();
    this.desktopInit();
    this.mobileInit();
  }

  movementInit() {
    const atc = document.querySelector(".product__form__wrapper");
    const footer = document.querySelector(".rao-footer--section");

    window.addEventListener("scroll", function() {
      if(atc.getBoundingClientRect().bottom <= 0 && footer.getBoundingClientRect().top > window.innerHeight) {
        this.classList.add("show");
      } else {
        this.classList.remove("show");
      }
    }.bind(this));
  }

  mobileInit() {
    const stickyForm = this.querySelector(".sticky__mobile--right");
    const addToCartInput = this.querySelector(`.sticky--mobile input[name="id"]`);
    const variantBtn = this.querySelector(".sticky__mobile--variant-btn");
    const variantValue = this.querySelector(".sticky__mobile--variant-value");
    let firstVariantChange = true;

    variantBtn.addEventListener("click", this.scrollToForm.bind(this));
    variantValue.addEventListener("click", this.scrollToForm.bind(this));

    window.addEventListener("theme:variant:change", function(e) {
      if(!firstVariantChange) {
        variantValue.innerText = e.detail.variant.option2;
        stickyForm.classList.remove("variants-hide");
        addToCartInput.value = e.detail.variant.id;
      }
      firstVariantChange = false;
    });
  }

  desktopInit() {
    this.form = document.querySelector(".product__form__wrapper");
    const stickyForm = this.querySelector(".sticky__desktop--form");
    const addToCartInput = this.querySelector(`.sticky--desktop input[name="id"]`);
    const variantBtn = this.querySelector(".sticky__desktop--variant-btn");
    const variantValue = this.querySelector(".sticky__desktop--variant-value");
    let firstVariantChange = true;

    variantBtn.addEventListener("click", this.scrollToForm.bind(this));
    variantValue.addEventListener("click", this.scrollToForm.bind(this));

    window.addEventListener("theme:variant:change", function(e) {
      if(!firstVariantChange) {
        variantValue.innerText = e.detail.variant.option2;
        stickyForm.classList.remove("variants-hide");
        addToCartInput.value = e.detail.variant.id;
      }
      firstVariantChange = false;
    });
  }

  scrollToForm() {
    this.form.scrollIntoView({behavior: "smooth", block: "center"});
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart);

class SwatchFiltersCollapsible extends HTMLElement {
  constructor() {
    super();
    this.rows = Number(this.dataset.showRows);
    this.height = Number(this.dataset.elementHeight);
    this.mobileHeight = Number(this.dataset.elementMobileHeight);
    this.totalShowRowsHeight = this.rows * this.height;
    this.collapsedHeight = this.height;
    this.totalShowRowsMobileHeight = this.rows * this.mobileHeight;
    this.blockHeight = this.offsetHeight;
    this.block = this.querySelector("[swatch-filters-block]");
    this.moreBtn = this.querySelector(".collection__filters-more");
  }

  connectedCallback() {
    this.init();
    window.addEventListener("resize", this.init.bind(this));
  }

  init() {
    this.block.style.maxHeight = `max-content`;
    this.blockHeight = this.offsetHeight;
    if (window.innerWidth < 768) {
      this.initMobile();
    } else {
      this.initDesktop();
    }
  }

  initMobile() {
    if (this.totalShowRowsMobileHeight < this.blockHeight) {
      this.block.style.maxHeight = `${this.totalShowRowsMobileHeight}px`;
      this.collapsedHeight = this.totalShowRowsMobileHeight;
      this.block.style.overflow = "hidden";
      this.moreBtn.classList.remove("hidden");
      this.moreBtn.addEventListener("click", this.toggle.bind(this));
    }
  }

  initDesktop() {
    if (this.totalShowRowsHeight < this.blockHeight) {
      this.block.style.maxHeight = `${this.totalShowRowsHeight}px`;
      this.collapsedHeight = this.totalShowRowsHeight;
      this.block.style.overflow = "hidden";
      this.moreBtn.classList.remove("hidden");
      this.moreBtn.addEventListener("click", this.toggle.bind(this));
    }
  }

  toggle() {
    if (this.moreBtn.classList.contains("is-expanded")) {
      this.moreBtn.classList.remove("is-expanded");
      this.block.style.maxHeight = `${this.collapsedHeight}px`;
    } else {
      this.moreBtn.classList.add("is-expanded");
      this.block.style.maxHeight = `${this.blockHeight}px`;
    }
  }
} 

customElements.define("swatch-filters-collapsible", SwatchFiltersCollapsible);


class PromotionalProductVersions extends HTMLElement {
  static basePropertyName = "properties[_promotional_base]";

  #data = null;
  #scope = null;
  #baseVariants = new Map();
  #baseVariant = null;
  #applyTimer = null;
  #cartQuantities = new Map();
  #cartLoaded = false;
  #promoInCart = false;
  #lastMatch = null;
  #splitting = false;

  connectedCallback() {
    this.#data = this.#readData();

    if (!this.#data) {
      return;
    }

    this.#scope = this.#resolveScope();
    this.#promoInCart = this.#data.promoInCart === true;

    for (const variant of this.#data.base.variants) {
      this.#baseVariants.set(String(variant.id), variant);
    }

    for (const candidate of this.#data.candidates) {
      candidate.distinctValueCounts = candidate.options.map((name, index) => new Set(candidate.variants.map((variant) => this.#normalize(variant.options[index]))).size);
    }

    this.onVariantChange = this.#onVariantChange.bind(this);
    this.onBeforeSubmit = this.#onBeforeSubmit.bind(this);
    this.onCartChange = this.#loadCart.bind(this);

    window.addEventListener("theme:variant:change", this.onVariantChange);
    document.addEventListener("click", this.onBeforeSubmit, true);
    document.addEventListener("submit", this.onBeforeSubmit, true);
    document.addEventListener("theme:cart:added", this.onCartChange);
    document.addEventListener("theme:cart:update", this.onCartChange);
    document.addEventListener("theme:cart:loaded", this.onCartChange);

    this.#loadCart();
    this.apply();
  }

  disconnectedCallback() {
    window.removeEventListener("theme:variant:change", this.onVariantChange);
    document.removeEventListener("click", this.onBeforeSubmit, true);
    document.removeEventListener("submit", this.onBeforeSubmit, true);
    document.removeEventListener("theme:cart:added", this.onCartChange);
    document.removeEventListener("theme:cart:update", this.onCartChange);
    document.removeEventListener("theme:cart:loaded", this.onCartChange);
    clearTimeout(this.#applyTimer);
  }

  #loadCart() {
    const cartUrl = window.theme?.routes?.cart_url || "/cart";

    fetch(`${cartUrl}.js`, {cache: "no-store"})
      .then((response) => response.json())
      .then((cart) => {
        const quantities = new Map();

        // One variant can sit in several lines at once, since differing line item properties keep them apart, and every one of them eats stock.
        for (const item of cart.items) {
          const key = String(item.variant_id);

          quantities.set(key, (quantities.get(key) || 0) + item.quantity);
        }

        this.#cartQuantities = quantities;
        this.#cartLoaded = true;

        // A line added for another promotion is only recognisable by its property, while our own group is recognisable either way.
        const taggedLine = cart.items.some((item) => item.properties && item.properties._promotional_base);
        const ownLine = cart.items.some((item) => this.#isCandidateVariant(item.variant_id));

        this.#promoInCart = taggedLine || ownLine;
        this.apply();
      })
      .catch((error) => console.error("Promotional product versions could not read the cart", error));
  }

  apply(baseVariant) {
    const variant = baseVariant || this.#currentBaseVariant();

    if (!variant) {
      return;
    }

    this.#baseVariant = variant;

    const match = this.#resolve(variant);
    const id = String(match ? match.variant.id : variant.id);

    this.#lastMatch = match;

    for (const input of this.#cartIdInputs()) {
      if (input.value !== id) {
        input.value = id;
      }

      this.#markBaseProduct(input.form, match);
    }

    this.#announce(match, variant);
  }

  // The cart line has no way back to the product the customer thinks they bought, so the swap leaves a hidden trail for it.
  #markBaseProduct(form, match) {
    if (!form) {
      return;
    }

    const name = PromotionalProductVersions.basePropertyName;
    const existing = form.querySelector(`input[name="${name}"]`);

    if (!match) {
      existing?.remove();

      return;
    }

    const input = existing || document.createElement("input");

    input.type = "hidden";
    input.name = name;
    input.value = this.#data.base.handle;

    if (!existing) {
      form.appendChild(input);
    }
  }

  #readData() {
    const holder = this.querySelector("[data-promotional-product-versions]");

    if (!holder) {
      return null;
    }

    try {
      const data = JSON.parse(holder.textContent);

      return data.candidates.length > 0 ? data : null;
    } catch (error) {
      console.error("Invalid promotional product versions JSON", error);

      return null;
    }
  }

  #resolveScope() {
    const form = this.closest("form");
    const section = this.closest(`[data-section-type="product-template"]`);

    // An upsell or quick buy form sits inside the main product section, so it must never reach past its own form.
    if (form && form.matches(`[data-product-form-upsell], [data-quickbuy-form]`)) {
      return form;
    }

    return this.closest("[data-quick-view-item]") || (section && section.closest(".shopify-section")) || form || this.parentElement;
  }

  #cartIdInputs() {
    const inputs = [...this.#scope.querySelectorAll(`form[data-product-form] input[name="id"]`)];
    const ownInput = this.closest("form")?.querySelector(`input[name="id"]`);

    if (ownInput && !inputs.includes(ownInput)) {
      inputs.push(ownInput);
    }

    return inputs.filter((input) => this.#ownsInputValue(input.value));
  }

  #isCandidateVariant(id) {
    return this.#data.candidates.some((candidate) => candidate.variants.some((variant) => String(variant.id) === String(id)));
  }

  #ownsInputValue(value) {
    if (value === "") {
      return true;
    }

    if (this.#baseVariants.has(String(value))) {
      return true;
    }

    return this.#isCandidateVariant(value);
  }

  #currentBaseVariant() {
    const input = this.#scope.querySelector(`form[data-product-form] input[name="id"]`) || this.closest("form")?.querySelector(`input[name="id"]`);
    const fromInput = input ? this.#baseVariants.get(String(input.value)) : null;

    return fromInput || this.#baseVariant;
  }

  #onVariantChange(event) {
    if (typeof event.target.contains !== "function" || !event.target.contains(this)) {
      return;
    }

    const variant = event.detail.variant;

    if (!variant) {
      this.#baseVariant = null;
      this.#announce(null, null);

      return;
    }

    this.apply(variant);

    clearTimeout(this.#applyTimer);
    this.#applyTimer = setTimeout(() => this.apply(variant), 0);
  }

  #onBeforeSubmit(event) {
    if (this.#splitting) {
      return;
    }

    const selector = event.type === "submit" ? `form[data-product-form]` : `[data-add-to-cart], [data-buy-it-now], .shopify-payment-button__button`;
    const trigger = event.target.closest?.(selector);

    if (!trigger || !this.#scope.contains(trigger)) {
      return;
    }

    this.apply();

    const form = event.type === "submit" ? trigger : trigger.closest("form");
    const quantity = this.#requestedQuantity(form);

    if (!this.#lastMatch || quantity < 2 || !this.#ownsForm(form)) {
      return;
    }

    // The theme posts one variant per add, so the only way to keep the promotion to a single unit is to take this add over.
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this.#addSplit(form, trigger, this.#lastMatch, quantity);
  }

  #addSplit(form, button, match, quantity) {
    const addUrl = `${window.theme?.routes?.cart_add_url || "/cart/add"}.js`;
    const payload = {
      items: [
        {id: match.variant.id, quantity: 1, properties: {_promotional_base: this.#data.base.handle}},
        {id: this.#baseVariant.id, quantity: quantity - 1}
      ]
    };

    this.#splitting = true;
    button?.classList.add("is-loading");

    fetch(addUrl, {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || response.message || "cart/add rejected the split");
        }

        if (window.cart) {
          window.cart.getCart();
        } else {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Promotional product versions could not split the add to cart", error);
        this.#addBaseInstead(form, button);
      })
      .finally(() => {
        button?.classList.remove("is-loading");
        this.#splitting = false;
      });
  }

  // Nobody should lose their add because the promotion failed, so hand the whole quantity back to the theme as the plain product.
  #addBaseInstead(form, button) {
    const input = form.querySelector(`input[name="id"]`);

    if (!input || !this.#baseVariant || !button) {
      return;
    }

    input.value = String(this.#baseVariant.id);
    this.#markBaseProduct(form, null);
    this.#splitting = true;
    button.click();
    this.#splitting = false;
  }

  // A promotional bundle is a one per cart offer, so a cart already holding one takes the plain base product from here on.
  #resolve(baseVariant) {
    if (this.#promoInCart) {
      return null;
    }

    const selected = this.#selectedOptions(baseVariant);
    const matches = [];

    this.#data.candidates.forEach((candidate, order) => {
      const variant = this.#matchVariant(candidate, selected);

      if (variant && variant.available && this.#remainingStock(candidate, variant) >= 1) {
        matches.push({candidate: candidate, variant: variant, order: order});
      }
    });

    matches.sort((left, right) => this.#compareScarcity(left, right));

    return matches[0] || null;
  }

  #requestedQuantity(form) {
    const field = (form || this.closest("form"))?.querySelector(`[name="quantity"]`);
    const wanted = field ? parseInt(field.value, 10) : 1;

    return Number.isNaN(wanted) || wanted < 1 ? 1 : wanted;
  }

  #ownsForm(form) {
    return Boolean(form) && this.#cartIdInputs().some((input) => input.form === form);
  }

  // Liquid counted the cart when the page rendered, so the fetch only has to keep that current, never to establish it.
  #inCart(variant) {
    if (this.#cartLoaded) {
      return this.#cartQuantities.get(String(variant.id)) || 0;
    }

    return typeof variant.inCart === "number" ? variant.inCart : 0;
  }

  // A bundle draws its stock from shared components, so every sibling variant in the cart eats the same pool, not just the matched one.
  #cartUsage(candidate) {
    return candidate.variants.reduce((total, variant) => total + this.#inCart(variant), 0);
  }

  // What is already in the cart is gone as far as this customer is concerned, so a maxed out version has to step aside for the next one.
  #remainingStock(candidate, variant) {
    if (!variant.tracked || variant.policy !== "deny" || typeof variant.inventory !== "number") {
      return Number.MAX_SAFE_INTEGER;
    }

    return variant.inventory - this.#cartUsage(candidate);
  }

  #compareScarcity(left, right) {
    const leftStock = this.#remainingStock(left.candidate, left.variant);
    const rightStock = this.#remainingStock(right.candidate, right.variant);

    if (leftStock !== rightStock) {
      return leftStock - rightStock;
    }

    return left.order - right.order;
  }

  #selectedOptions(baseVariant) {
    const selected = new Map();

    this.#data.base.options.forEach((name, index) => selected.set(this.#normalize(name), this.#normalize(baseVariant.options[index])));

    return selected;
  }

  #matchVariant(candidate, selected) {
    const constraints = [];

    for (let index = 0; index < candidate.options.length; index += 1) {
      const name = this.#normalize(candidate.options[index]);

      if (selected.has(name)) {
        constraints.push([index, selected.get(name)]);
        continue;
      }

      // An option the base product does not carry can only be ignored while it holds a single value, which is how a bundle keeps its pruned "Title" option.
      if (candidate.distinctValueCounts[index] > 1) {
        return null;
      }
    }

    const match = candidate.variants.find((variant) => constraints.every(([index, value]) => this.#normalize(variant.options[index]) === value));

    return match || null;
  }

  #announce(match, baseVariant) {
    this.dataset.activeHandle = match ? match.candidate.handle : "";

    this.dispatchEvent(new CustomEvent("theme:promotional-version:change", {
      bubbles: true,
      detail: {
        candidate: match ? match.candidate : null,
        variant: match ? match.variant : null,
        baseVariant: baseVariant
      }
    }));
  }

  #normalize(value) {
    return value === null || value === undefined ? "" : String(value).trim().toLowerCase();
  }
}

customElements.define("promotional-product-versions", PromotionalProductVersions);

// The cart re-enables every input and button it renders, so a promotional line has to be locked again after each rebuild.
function lockPromotionalCartItems() {
  for (const item of document.querySelectorAll("[data-promo-locked]")) {
    for (const control of item.querySelectorAll("[data-quantity-button], [data-quantity-field], [data-popout-quantity]")) {
      if (!control.disabled) {
        control.disabled = true;
      }
    }

    const holder = item.querySelector("[data-quantity-holder]");

    if (holder && !holder.classList.contains("is-disabled")) {
      holder.classList.add("is-disabled");
    }
  }
}

document.addEventListener("theme:cart:added", lockPromotionalCartItems);
document.addEventListener("theme:cart:loaded", lockPromotionalCartItems);
document.addEventListener("theme:cart:update", lockPromotionalCartItems);
window.addEventListener("DOMContentLoaded", function() {
  lockPromotionalCartItems();

  new MutationObserver(lockPromotionalCartItems).observe(document.body, {childList: true, subtree: true, attributeFilter: ["disabled"]});
});
